import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function CitySearch(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#66CCFF" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M18.9999 12.0001C18.9999 15.8662 15.8658 19.0003 11.9997 19.0003C8.13361 19.0003 4.99951 15.8662 4.99951 12.0001C4.99951 8.13397 8.13361 4.99988 11.9997 4.99988C15.8658 4.99988 18.9999 8.13397 18.9999 12.0001ZM17.2498 12C17.2498 14.8996 14.8992 17.2501 11.9996 17.2501C9.10004 17.2501 6.74947 14.8996 6.74947 12C6.74947 9.1004 9.10004 6.74983 11.9996 6.74983C14.8992 6.74983 17.2498 9.1004 17.2498 12ZM8.4998 12C8.4998 11.1024 8.83773 10.2836 9.39332 9.66408L11.4162 11.125L11.8532 8.50295C11.9018 8.50094 11.9507 8.49993 11.9999 8.49993C13.933 8.49993 15.5 10.067 15.5 12C15.5 13.9331 13.933 15.5001 11.9999 15.5001C10.0668 15.5001 8.4998 13.9331 8.4998 12Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

CitySearch.propTypes = propTypes;
CitySearch.defaultProps = defaultProps;

export default CitySearch;
